<template>
  <SafelyHydrate class="flex items-center justify-end gap-4 lg:gap-8">
    <!-- Search only for tablets -->
    <HeaderSearch class="hidden md:block lg:hidden" />
    <button
      v-if="isPdp && isMobile"
      class="-mx-2 p-2 md:hidden"
      :class="{ 'opacity-50': isMobileSearchBarVisible }"
      :title="$t('search.search')"
      :aria-label="$t('search.search')"
      @click="isMobileSearchBarVisible = !isMobileSearchBarVisible"
    >
      <IconSearch class="size-6 scale-110" />
    </button>
    <HeaderLanguageSwitch />
    <AgsLink
      v-if="!isLoggedIn || user?.status?.isGuestCustomer"
      :to="toLocalePath(routeList.signin.name)"
      size="sm"
      data-qa="profile-icon"
      data-test-id="sign-in-link"
      @click="trackNavigationHeader($t('global.sign_in'))"
    >
      <template #icon>
        <IconLogin class="size-6" />
      </template>
      <span class="hidden items-center justify-center text-sm lg:flex">
        {{ $t('global.sign_in') }}
      </span>
    </AgsLink>
    <UserPopover v-else />
    <AgsLink
      data-test-id="wishlist-link"
      data-qa="wish-list"
      :to="toLocalePath(routeList.wishlist.name)"
      type="loud"
      :badge="(wishlistCount || 0) > 0 ? wishlistCount : undefined"
      :aria-label="$t('navigation.wishlist')"
      @click="trackNavigationHeader($t('navigation.wishlist'))"
    >
      <template #icon>
        <IconHearth class="size-6" />
      </template>
      <span
        class="hidden items-center justify-center text-sm normal-case lg:flex"
      >
        {{ $t('navigation.wishlist') }}
      </span>
    </AgsLink>
    <AgsLazy ssr>
      <BasketPopover
        :items="basketItems"
        :count="countAvailableBasketItems(basketItems)"
        class="mt-1"
      />
    </AgsLazy>
  </SafelyHydrate>
</template>

<script lang="ts" setup>
const { trackNavigationHeader } = useTrackingEvents()
const { isPdp, isMobileSearchBarVisible } = useUiState()
const { toLocalePath } = useRouteHelpers()
const { isMobile } = useDeviceType()

const [
  { countAvailableBasketItems, data: basketData },
  { user, isLoggedIn },
  { count: wishlistCount },
] = await Promise.all([useAgsBasket(), useAgsUser(), useAgsWishlist()])

const basketItems = computed(() => {
  const items = basketData.value?.items
  if (!items) {
    return []
  }
  return [...items].sort(
    (a, b) => Number(a.product.isSoldOut) - Number(b.product.isSoldOut),
  )
})
</script>
